/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Blueprint,
  Blueprints,
  BlueprintsParams,
  FilterOptionsList,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Blueprints list
 */
export const blueprints = (
    params?: MaybeRefOrGetter<BlueprintsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Blueprints>(
      {url: `/blueprints`, method: 'GET',
        params, signal
    },
      );
    }




export const getBlueprintsQueryKey = (params?: MaybeRefOrGetter<BlueprintsParams>,) => {
    return [
    'blueprints', ...(params ? [params] : [])
    ] as const;
    }


export const getBlueprintsQueryOptions = <TData = Awaited<ReturnType<typeof blueprints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<BlueprintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getBlueprintsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof blueprints>>> = ({ signal }) => blueprints(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof blueprints>>, TError, TData>
}

export type BlueprintsQueryResult = NonNullable<Awaited<ReturnType<typeof blueprints>>>
export type BlueprintsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Blueprints list
 */

export function useBlueprints<TData = Awaited<ReturnType<typeof blueprints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<BlueprintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBlueprintsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Blueprint craftable types
 */
export const blueprintCraftableTypes = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/blueprints/craftable_type_filters`, method: 'GET', signal
    },
      );
    }




export const getBlueprintCraftableTypesQueryKey = () => {
    return [
    'blueprints','craftable_type_filters'
    ] as const;
    }


export const getBlueprintCraftableTypesQueryOptions = <TData = Awaited<ReturnType<typeof blueprintCraftableTypes>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprintCraftableTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getBlueprintCraftableTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof blueprintCraftableTypes>>> = ({ signal }) => blueprintCraftableTypes(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof blueprintCraftableTypes>>, TError, TData>
}

export type BlueprintCraftableTypesQueryResult = NonNullable<Awaited<ReturnType<typeof blueprintCraftableTypes>>>
export type BlueprintCraftableTypesQueryError = ErrorType<StandardError>


/**
 * @summary Blueprint craftable types
 */

export function useBlueprintCraftableTypes<TData = Awaited<ReturnType<typeof blueprintCraftableTypes>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprintCraftableTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBlueprintCraftableTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Blueprint materials
 */
export const blueprintMaterials = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/blueprints/material_filters`, method: 'GET', signal
    },
      );
    }




export const getBlueprintMaterialsQueryKey = () => {
    return [
    'blueprints','material_filters'
    ] as const;
    }


export const getBlueprintMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof blueprintMaterials>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprintMaterials>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getBlueprintMaterialsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof blueprintMaterials>>> = ({ signal }) => blueprintMaterials(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof blueprintMaterials>>, TError, TData>
}

export type BlueprintMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof blueprintMaterials>>>
export type BlueprintMaterialsQueryError = ErrorType<StandardError>


/**
 * @summary Blueprint materials
 */

export function useBlueprintMaterials<TData = Awaited<ReturnType<typeof blueprintMaterials>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprintMaterials>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBlueprintMaterialsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Blueprint orgs
 */
export const blueprintOrgs = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/blueprints/org_filters`, method: 'GET', signal
    },
      );
    }




export const getBlueprintOrgsQueryKey = () => {
    return [
    'blueprints','org_filters'
    ] as const;
    }


export const getBlueprintOrgsQueryOptions = <TData = Awaited<ReturnType<typeof blueprintOrgs>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprintOrgs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getBlueprintOrgsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof blueprintOrgs>>> = ({ signal }) => blueprintOrgs(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof blueprintOrgs>>, TError, TData>
}

export type BlueprintOrgsQueryResult = NonNullable<Awaited<ReturnType<typeof blueprintOrgs>>>
export type BlueprintOrgsQueryError = ErrorType<StandardError>


/**
 * @summary Blueprint orgs
 */

export function useBlueprintOrgs<TData = Awaited<ReturnType<typeof blueprintOrgs>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprintOrgs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBlueprintOrgsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Blueprint Detail
 */
export const blueprint = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Blueprint>(
      {url: `/blueprints/${id}`, method: 'GET', signal
    },
      );
    }




export const getBlueprintQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'blueprints',id
    ] as const;
    }


export const getBlueprintQueryOptions = <TData = Awaited<ReturnType<typeof blueprint>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprint>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getBlueprintQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof blueprint>>> = ({ signal }) => blueprint(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof blueprint>>, TError, TData>
}

export type BlueprintQueryResult = NonNullable<Awaited<ReturnType<typeof blueprint>>>
export type BlueprintQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Blueprint Detail
 */

export function useBlueprint<TData = Awaited<ReturnType<typeof blueprint>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof blueprint>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBlueprintQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






